import React, { useState } from "react";
import Header from "../components/Header";
import Breadcrumbs from "../components/Breadcrumbs";
import Footer from "../components/Footer";
import { MdDescription } from "react-icons/md";

export default function PatientFamBillOfRights() {
  const [hovered, setHovered] = useState("t&c");

  const breadcrumbItems = [
    {
      label: "Home",
      active: hovered === "home",
      onClick: () => {},
      onMouseEnter: () => setHovered("home"),
      onMouseLeave: () => setHovered(null),
    },
    {
      label: "Terms & Conditions",
      active: hovered === "t&c" || hovered === null,
      onClick: () => {},
      onMouseEnter: () => setHovered("t&c"),
      onMouseLeave: () => setHovered("t&c"),
    },
  ];

  // -----------------------------
  // UPDATED SECTIONS WITH JSX SAFE BOLD
  // -----------------------------
  const termsSections = [
    {
      title: "Your Rights as a VeriMED Patient/Client or Family Member",
      desc: "As a patient/client (or responsible family member), you have the right to:",
      items: [
        {
          number: 1,
          title: "Be Treated with Dignity and Respect",
          desc: "Receive care that honors your cultural values, personal preferences, and spiritual beliefs.",
        },
        {
          number: 2,
          title: "Be Fully Informed",
          desc: "Understand your care plan, available services, treatment options, and any changes to your health plan in a language and manner that is clear and appropriate.",
        },
        {
          number: 3,
          title: "Participate in Care Planning",
          desc: "Collaborate actively with our clinical and care navigation teams in developing, updating, or changing your care or wellness plan.",
        },
        {
          number: 4,
          title: "Confidentiality and Privacy",
          desc: "Expect that all medical information will be protected in accordance with global standards of privacy, and only shared with authorized individuals or providers involved in your care.",
        },
        {
          number: 5,
          title: "Choose and Consent to Care",
          desc: "Make informed decisions about your treatment, including the right to refuse care or withdraw from services at any time, within the boundaries of law and safety.",
        },
        {
          number: 6,
          title: "Continuity and Coordination of Care",
          desc: "Receive seamless, coordinated services and referrals to other providers when needed for your ongoing health and recovery.",
        },
        {
          number: 7,
          title: "Timely Access to Professionals",
          desc: "Expect timely responses from our medical team and access to urgent or emergency services when necessary.",
        },
        {
          number: 8,
          title: "Safe and Respectful Environment",
          desc: "Receive care in a clean, safe, and respectful setting—whether at home, online, or at our health facility.",
        },
        {
          number: 9,
          title: "File Complaints or Express Concerns",
          desc: "Voice concerns about your care without fear of discrimination or reprisal. You may submit feedback directly to our Client Experience Specialist via phone, WhatsApp, or email.",
        },
        {
          number: 10,
          title: "Designate a Family Representative",
          desc: "Authorize a trusted individual (especially if living abroad) to receive updates, make decisions, and coordinate your care on your behalf if needed.",
        },
      ],
    },

    {
      title:
        "Your Responsibilities as a VeriMED Patient/Client or Family Member",
      desc: "To help us deliver excellent care, we ask that you:",
      items: [
        {
          number: 1,
          title: "Provide Accurate Health Information",
          desc: "Share truthful, complete, and updated medical history, medication details, and health concerns.",
        },
        {
          number: 2,
          title: "Notify Us of Changes or Emergencies",
          desc: "Inform our team promptly if there are any significant changes in condition, address, availability, or hospital visits.",
        },
        {
          number: 3,
          title: "Respect Our Team",
          desc: "Treat all caregivers, nurses, and physicians with courtesy, kindness, and cultural respect.",
        },
        {
          number: 4,
          title: "Follow Agreed Care Plans",
          desc: "Cooperate with recommended care, treatments, and instructions, and communicate if you have any questions or concerns.",
        },
        {
          number: 5,
          title: "Honor Scheduled Appointments",
          desc: "Notify us in advance if you need to cancel or reschedule home visits or virtual appointments.",
        },
        {
          number: 6,
          title: "Fulfill Financial Agreements",
          desc: "Ensure timely payment for services, whether through membership plans, family-sponsored care, or per-visit billing.",
        },
        {
          number: 7,
          title: "Ask Questions and Stay Involved",
          desc: "Stay informed and actively involved in the ongoing care of your loved one.",
        },
        {
          number: 8,
          title: "Share Feedback Openly",
          desc: "Help us improve by providing constructive feedback or reporting concerns directly to our office.",
        },
      ],
    },
  ];

  return (
    <div className="terms_container">
      <Header />

      {/* Terms & Conditions Content */}
      <div className="terms_content">
        <div className="terms_header">
          <p>Verimed - Patient and family bill of rights</p>
          <p>11 December, 2025</p>
        </div>

        {termsSections.map((section, index) => (
          <div key={index} className="terms_section">
            <h2 className="terms_section_title">{section.title}</h2>

            {section.desc && (
              <p className="terms_section_desc">{section.desc}</p>
            )}

            {section.items && (
              <ul className="terms_section_list">
                {section.items.map((item, i) => (
                  <li key={i}>
                    <strong>
                      {item.number}. {item.title}
                    </strong>
                    <br />
                    {item.desc}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
}
